var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconBlockSlider(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21,6h-1V3c0-1.7-1.3-3-3-3H3C1.3,0,0,1.3,0,3v14c0,1.7,1.3,3,3,3h3v1c0,1.7,1.3,3,3,3h12c1.7,0,3-1.3,3-3V9 C24,7.3,22.7,6,21,6z M3,18c-0.5,0-1-0.5-1-1V3c0-0.5,0.5-1,1-1h14c0.5,0,1,0.5,1,1v14c0,0.5-0.5,1-1,1H3z M22,21c0,0.5-0.5,1-1,1 H9c-0.5,0-1-0.5-1-1v-1h9c1.7,0,3-1.3,3-3V8h1c0.5,0,1,0.5,1,1V21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18,3v14c0,0.5-0.5,1-1,1H3c-0.5,0-1-0.5-1-1V3c0-0.5,0.5-1,1-1h14C17.5,2,18,2.5,18,3z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBlockSlider);
export default __webpack_public_path__ + "static/media/icon-block-slider.72293159c64256a7f61965b3c05a9f93.svg";
export { ForwardRef as ReactComponent };